import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getMonitoringLogs } from '@/service/alerts'

const emptyPage = {
  list: [],
  totalRow: 0,
  pageNumber: 1,
  pageSize: 20,
  totalPage: 0,
  hasMore: false
}

export const fetchMonitoringLogs = createAsyncThunk(
  'monitoringLogs/fetchMonitoringLogs',
  async ({ query = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await getMonitoringLogs(query)
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.msg ||
          error?.message ||
          '加载预警记录失败'
      )
    }
  }
)

const monitoringLogsSlice = createSlice({
  name: 'monitoringLogs',
  initialState: {
    fetching: false,
    error: null,
    query: {},
    data: { ...emptyPage }
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonitoringLogs.pending, (state) => {
        state.fetching = true
        state.error = null
      })
      .addCase(fetchMonitoringLogs.fulfilled, (state, action) => {
        state.fetching = false
        state.error = null
        state.query = action.payload.query
        state.data = action.payload.data || { ...emptyPage }
      })
      .addCase(fetchMonitoringLogs.rejected, (state, action) => {
        state.fetching = false
        state.error = action.payload ?? action.error?.message ?? null
        state.data = { ...emptyPage }
      })
  }
})

export default monitoringLogsSlice.reducer
